<div class="my-work">
  <action-title-header
    [title]="'MyWork.title' | translate"
    [stickyWithSideNavigation]="true"
  >
    <ng-template #action>
      <app-button
        [matMenuTriggerFor]="headerAddMenu"
        [config]="{
          size: ButtonSize.LARGE,
          type: ButtonTypes.NEW_PRIMARY_BLUE,
          text: ('MyWork.addItem' | translate),
          prependSrc: './assets/img/ic-plus-add.svg'
        }"
      />
    </ng-template>
    <mat-menu #headerAddMenu="matMenu" xPosition="before" class="menu-v2">
      <button mat-menu-item type="button" (click)="createNewTask(TaskType.TYPE_TASK)">
        {{ 'TaskType.task' | translate }}
      </button>
      <button mat-menu-item type="button" (click)="createNewTask(TaskType.TYPE_ORDER)">
        {{ 'TaskType.order' | translate }}
      </button>
      <button mat-menu-item type="button" (click)="createNewTask(TaskType.TYPE_CORRECTION)">
        {{ 'TaskType.correction' | translate }}
      </button>
    </mat-menu>
    <list-search />
    <div class="work-list__tabs">
      <button-group-v2 [config]="buttonGroupConfig" (onClick)="onTabClick($event)" class="w-100 w-sm-auto" />
    </div>
    <list-filters-btn-v2 [filters]="MyWorkFiltersComponent" />
  </action-title-header>

  <div class="my-work__content">
    <div class="my-work__content__tasks">
      <app-list-chips-active-filters [component]="MyWorkFiltersComponent" />

      <ng-select
        [ngStyle]="{ display: 'none' }"
        #selectTab
        ngSelectExtension
        class="select select-default my-work__content__select-tabs"
        [dropdownPosition]="'bottom'"
        [items]="tabs"
        [clearable]="false"
        [searchable]="false"
        [bindLabel]="'text'"
        [bindValue]="'id'"
        [placeholder]="'Projects.tabs' | translate"
        (change)="onTabClick($event)"
        [tabIndex]="-1"
      />

      <div class="my-work__tasks-section">
        <div class="my-work__tasks-section-header">
          <h4 class="my-work__tasks-title">{{ 'Projects.projectTasks' | translate }}</h4>
          <app-button
            *ngIf="!delegatedTasksMode()"
            (onClick)="createMyWorkTaskGroup('project')"
            [config]="{
              size: ButtonSize.SMALL,
              type: ButtonTypes.NEW_SECONDARY_BLUE,
              text: ('Projects.newGroup' | translate),
              prependSrc: './assets/img/ic-plus.svg'
            }"
          />
          <button
            type="button"
            class="my-work__columns-button"
            [matMenuTriggerFor]="projectColumnsMenu"
            [attr.aria-label]="'MyWork.Columns.show' | translate"
          >
            <img src="./assets/img/eye-icon.svg" alt="" aria-hidden="true" />
          </button>
          <mat-menu #projectColumnsMenu="matMenu" xPosition="before" class="menu-v2 my-work-columns-menu">
            <ng-container *ngTemplateOutlet="myWorkColumnsMenuContent"></ng-container>
          </mat-menu>
        </div>

        @if (initialLoading()) {
          <div class="d-flex align-items-center justify-content-center my-5">
            <div class="lds-dual-ring"></div>
          </div>
        } @else {
          <list-tasks
            [groups]="projectGroups()"
            layout="my-work"
            [loading]="loading()"
            [accordionMode]="true"
            [accordionMultiExpand]="true"
            [accordionAllowSingleGroup]="true"
            [accordionStorageKey]="projectAccordionStorageKey()"
            (taskDropped)="onTaskDrop($event)"
            (taskStatusChanged)="onTaskStatusChanged($event)"
            (groupEditRequested)="onGroupEditRequested($event)"
            (groupOrderChanged)="onProjectGroupOrderChanged($event)"
            (typedAddTask)="onAddTaskToGroup($event)"
          />
        }
      </div>

      <div class="my-work__tasks-section mt-3 mb-4">
        <div class="my-work__tasks-section-header">
          <h4 class="my-work__tasks-title">{{ 'Projects.withoutProjectTasks' | translate }}</h4>
          <app-button
            *ngIf="!delegatedTasksMode()"
            (onClick)="createMyWorkTaskGroup('without_project')"
            [config]="{
              size: ButtonSize.SMALL,
              type: ButtonTypes.NEW_SECONDARY_BLUE,
              text: ('Projects.newGroup' | translate),
              prependSrc: './assets/img/ic-plus.svg'
            }"
          />
          <button
            type="button"
            class="my-work__columns-button"
            [matMenuTriggerFor]="withoutProjectColumnsMenu"
            [attr.aria-label]="'MyWork.Columns.show' | translate"
          >
            <img src="./assets/img/eye-icon.svg" alt="" aria-hidden="true" />
          </button>
          <mat-menu #withoutProjectColumnsMenu="matMenu" xPosition="before" class="menu-v2 my-work-columns-menu">
            <ng-container *ngTemplateOutlet="myWorkColumnsMenuContent"></ng-container>
          </mat-menu>
        </div>

        @if (initialLoading()) {
          <div class="d-flex align-items-center justify-content-center my-5">
            <div class="lds-dual-ring"></div>
          </div>
        } @else {
          <list-tasks
            [groups]="withoutProjectGroups()"
            layout="my-work"
            [loading]="loading()"
            [accordionMode]="true"
            [accordionMultiExpand]="true"
            [accordionAllowSingleGroup]="true"
            [accordionStorageKey]="withoutProjectAccordionStorageKey()"
            (taskDropped)="onTaskDrop($event)"
            (taskStatusChanged)="onTaskStatusChanged($event)"
            (groupEditRequested)="onGroupEditRequested($event)"
            (groupOrderChanged)="onWithoutProjectGroupOrderChanged($event)"
            (typedAddTask)="onAddTaskToGroup($event)"
          />
        }
      </div>
    </div>
  </div>
</div>

<ng-template #myWorkColumnsMenuContent>
  <div class="my-work-columns-menu__list" (click)="$event.stopPropagation()">
    <div class="my-work-columns-menu__title">{{ 'MyWork.Columns.show' | translate }}</div>
    @for (column of myWorkColumns.columns; track column) {
      <div class="form-control-checkbox my-work-columns-menu__option">
        <label class="m-0 d-flex align-items-center">
          <input type="checkbox" [checked]="myWorkColumns.isVisible(column)" (change)="toggleMyWorkColumn(column)" />
          <span></span>
          <span>{{ 'MyWork.Columns.' + column | translate }}</span>
        </label>
      </div>
    }
  </div>
</ng-template>
